<template>
  <div class="pt-3 pb-2 px-5">
    <v-simple-table>
      <tbody>
        <tr v-if="job.occupations">
          <td class="items">職種</td>
          <td class="pre-wrap">{{occupations}}</td>
        </tr>
        <tr v-if="job.detail">
          <td class="items">募集業務の詳細</td>
          <td class="pre-wrap">{{job.detail}}</td>
        </tr>
        <tr v-if="job.techStack">
          <td class="items">技術スタック</td>
          <td class="pre-wrap">{{job.techStack}}</td>
        </tr>
        <tr/>
      </tbody>
    </v-simple-table>
    <v-simple-table v-if="loggedIn">
      <tbody>
        <tr v-if="job.mustRequirement">
          <td class="items">必要要件</td>
          <td class="pre-wrap">{{job.mustRequirement}}</td>
        </tr>
        <tr v-if="job.welcomeRequirement">
          <td class="items">推奨要件</td>
          <td class="pre-wrap">{{job.welcomeRequirement}}</td>
        </tr>
        <tr v-if="job.idealPersonType">
          <td class="items">求める人物像</td>
          <td class="pre-wrap">{{job.idealPersonType}}</td>
        </tr>
        <tr v-if="job.handsOn != null">
          <td class="items">実務経験</td>
          <td class="pre-wrap">{{constsToText(job.handsOn, handsOns)}}</td>
        </tr>
        <tr v-if="openSliderForm">
          <td class="items">働き方</td>
          <td class="pre-wrap">
            <RateSlider v-if="job.resourceType" :value="job.resourceType" readonly class="mb-4">
              <template v-slot:left>データサイエンティスト（アナリスト）</template>
              <template v-slot:right>機械学習（AI）エンジニア</template>
            </RateSlider>
            <RateSlider v-if="job.developmentType" :value="job.developmentType" readonly class="mb-4">
              <template v-slot:left>自社開発</template>
              <template v-slot:right>受託開発</template>
            </RateSlider>
            <RateSlider v-if="job.companyScale" :value="job.companyScale" readonly class="mb-4">
              <template v-slot:left>大企業</template>
              <template v-slot:right>ベンチャー</template>
            </RateSlider>
            <RateSlider  v-if="job.workingStance" :value="job.workingStance" readonly class="mb-4">
              <template v-slot:left>少数のプロジェクトに深く携わる</template>
              <template v-slot:right>多くのプロジェクトに幅広く携わる</template>
            </RateSlider>
          </td>
        </tr>
        <tr v-if="job.lowerSalary || job.upperSalary">
          <td class="items">年収</td>
          <td>{{job.lowerSalary}} 〜 {{job.upperSalary}} 万円</td>
        </tr>
        <tr v-if="job.salaryMemo">
          <td class="items">年収の補足事項</td>
          <td class="pre-wrap">{{job.salaryMemo}}</td>
        </tr>
        <tr v-if="side.hourlyWageMin || side.hourlyWageMax">
          <td class="items">時間単価</td>
          <td class="pre-wrap">{{side.hourlyWageMin}} 〜 {{side.hourlyWageMax}}円/時間</td>
        </tr>
        <tr v-if="side.workingHoursWeekMin || side.workingHoursWeekMax">
          <td class="items">勤務時間/週</td>
          <td class="pre-wrap">{{side.workingHoursWeekMin}} 〜 {{side.workingHoursWeekMax}}時間/週</td>
        </tr>
        <tr />
      </tbody>
    </v-simple-table>
    <div v-else :class="maskClass">
      <div class="text-center" style="display: table-cell;vertical-align: middle">
        <p>ご登録いただくと全ての求人の詳細をご確認いただけます</p>
        <v-btn
            color="error" width="500px" height="64px"
            class="font-weight-bold mb-8"
            style="font-size: 24px"
            @click="login('signUp')"
        >プロフィール登録して詳細を確認する</v-btn>
      </div>
    </div>
    <v-simple-table>
      <tbody>
        <tr v-if="prefecture || job.address || job.building">
          <td class="items">勤務地</td>
          <td>{{job.zipCode}} {{prefecture}} {{job.address}} {{job.building}}</td>
        </tr>
        <tr v-if="job.nearestStation">
          <td class="items">勤務地の最寄り駅</td>
          <td class="pre-wrap">{{job.nearestStation}}</td>
        </tr>
        <tr v-if="job.employmentStatus">
          <td class="items">雇用形態</td>
          <td>
            {{constsToText(job.employmentStatus,consts.employmentStatus)}}
          </td>
        </tr>
        <tr v-if="job.workingHours">
          <td class="items">勤務形態</td>
          <td>
            {{constsToText(job.workingHours, consts.workingHours)}}
          </td>
        </tr>
        <tr v-if="!!(job.workingHourFrom) && !!(job.workingHourTo)">
          <td class="items">勤務時間詳細</td>
          <td>{{job.workingHourFrom}} 〜 {{job.workingHourTo}}</td>
        </tr>
        <tr v-if="side.availabilityDaytime">
          <td class="items">想定勤務時間帯 平日昼</td>
          <td class="pre-wrap">{{constsToText(side.availabilityDaytime, workAvailables)}}</td>
        </tr>
        <tr v-if="side.availabilityEvening">
          <td class="items">想定勤務時間帯 平日夜</td>
          <td class="pre-wrap">{{constsToText(side.availabilityEvening, workAvailables)}}</td>
        </tr>
        <tr v-if="side.availabilityHoliday">
          <td class="items">想定勤務時間帯 土日祝</td>
          <td class="pre-wrap">{{constsToText(side.availabilityHoliday, workAvailables)}}</td>
        </tr>
        <tr v-if="side.contractPeriod">
          <td class="items">想定契約期間</td>
          <td class="pre-wrap">{{constsToText(side.contractPeriod, contractPeriodItems)}}</td>
        </tr>
        <tr v-if="job.remoteStatus">
          <td class="items">リモート可否</td>
          <td class="pre-wrap">{{constsToText(job.remoteStatus, remoteStatuses)}}</td>
        </tr>
        <tr v-if="job.companyAppealPoint">
          <td class="items">アピールポイント</td>
          <td>
            {{constsToText(job.companyAppealPoint, consts.companyAppealPoint)}}
          </td>
        </tr>
        <tr v-if="job.employeeBenefits && job.employeeBenefits.length > 0">
          <td class="items">待遇・福利厚生</td>
          <td>
            {{constsToText(job.employeeBenefits, consts.employeeBenefit)}}
          </td>
        </tr>
        <tr v-if="job.benefit">
          <td class="items">その他待遇・福利厚生</td>
          <td>
            <div class="pre-wrap">{{job.benefit}}</div>
          </td>
        </tr>
        <tr v-if="job.numRecruit">
          <td class="items">採用人数</td>
          <td>{{job.numRecruit}}</td>
        </tr>
        <tr v-if="job.specialNotes">
          <td class="items">その他・特記事項</td>
          <td class="pre-wrap">{{job.specialNotes}}</td>
        </tr>
        <tr v-if="side.appealPoints">
          <td class="items">アピールポイント</td>
          <td class="pre-wrap">{{constsToText(side.appealPoints, appealPointSides)}}</td>
        </tr>
        <tr v-if="side.specialNotes">
          <td class="items">その他・特記事項</td>
          <td class="pre-wrap">{{side.specialNotes}}</td>
        </tr>
      </tbody>
    </v-simple-table>
  </div>
</template>

<script>
  import ComponentMixin from "../ComponentMixin";
  import ApiMixin from "../../ApiMixin";
  import { mapGetters } from "vuex";
  import RateSlider from "@/components/atoms/RateSlider";

  export default {
    components: {RateSlider},
    mixins: [ComponentMixin, ApiMixin],
    type: "organism",
    name: "JobDetail",
    props: {
      job: {
        type: Object,
        required: true
      },
      showStatusChip: Boolean
    },
    computed: {
      ...mapGetters("system", ["consts"]),
      ...mapGetters("user", ["user"]),
      loggedIn () {
        return this.$auth.isAuthenticated
      },
      isCandidate () {
        return !!this.user.candidate
      },
      isClient () {
        return !!this.$route.meta.isClient
      },
      occupations() {
        if (!this.job.occupations) return ''

        const occupationArray = this.job.occupations.map(value => this.constsToText(value, this.consts.jobOccupation))
        return occupationArray.join(', ')
      },
      prefecture() {
        const prefecture_num = Number(this.job.prefecture)
        if (prefecture_num !== 0){
          return this.constsToText(prefecture_num, this.consts.prefectures)
        }
        return "";
      },
      side () {
        return this.job.side || {}
      },
      maskClass() {
        return this.job.side ? "mask_side_job" : "mask_main_job";
      },
      openSliderForm() {
        return !this.job.side && (
          this.job.workingStance
          || this.job.companyScale
          || this.job.developmentType
          || this.job.resourceType
        )
      },
      workAvailables() {
        return [
          {label: "実働をお願いしたい", value: 1},
          {label: "連絡だけでOK", value: 2},
          {label: "連絡不可でもOK", value: 3}
        ]
      },
      contractPeriodItems() {
        return [
          {label: "1ヶ月", value: 1},
          {label: "3ヶ月", value: 2},
          {label: "6ヶ月超", value: 3},
        ]
      },
      remoteStatuses() {
        return [
          {label: "フルリモート", value: 1},
          {label: "一部リモート", value: 2},
          {label: "リモートなし", value: 3},
        ]
      },
      handsOns() {
        return [
          {label: "実務経験必須", value: 1},
          {label: "実務未経験可", value: 2},
        ]
      },
      appealPointSides() {
        return this.consts.jobSideAppealPoint
      }
    },
    methods: {
      login (initialScreen) {
        localStorage.setItem('nishika_redirect', window.location.href)
        this.$auth.loginWithRedirect({
          ui_locales: this.$i18n.locale,
          initialScreen: initialScreen,
        });
      },
    },
    watch: {
    }
  }
</script>

<style scoped lang="sass">
.pre-wrap
  white-space: pre-wrap
td
  padding-top: 14px
  padding-bottom: 14px
.items
  width: 210px
  vertical-align: top
.mask_main_job
    background-image: url('../../assets/mask_main_job.png')
    background-repeat: no-repeat
    background-size: cover
    background-position: center center
    display: table
    height: 405px
    width: 927px
    color: #ffffff
    font-size: 16px

.mask_side_job
    background-image: url('../../assets/mask_side_job.png')
    background-repeat: no-repeat
    background-size: cover
    background-position: center center
    display: table
    height: 259px
    width: 927px
    color: #ffffff
    font-size: 16px
</style>
